import type { CustomerDetailsPayload } from "@expert/sales-tools";

import type { ChannelShareData } from "@/call-details/api/types";

export interface SupportedProfileAnalyticsPayload {
    planId: string | undefined;
    RetailName: string | undefined;
    AccountType: string | undefined;
    AccountCategory: string | undefined;
    EnrollmentStatus: string | undefined;
    numPreviousDevices: number;
    currentSubscriptions: string[] | undefined;
}

export interface BuildSupportedProfileAnalyticsParams {
    customerData: CustomerDetailsPayload | undefined;
    callDetails: ChannelShareData;
    currentSubscriptions: string[] | undefined;
}

export function buildSupportedProfileAnalyticsPayload(
    params: BuildSupportedProfileAnalyticsParams,
): SupportedProfileAnalyticsPayload {
    const { customerData, callDetails, currentSubscriptions } = params;

    return {
        planId: customerData?.primaryAccountHolder?.planId,
        RetailName: customerData?.primaryAccountHolder?.productName,
        AccountType: callDetails.ACCOUNT_TYPE,
        AccountCategory: callDetails.ACCOUNT_CATEGORY,
        EnrollmentStatus: callDetails.VALIDATION_FLAG,
        numPreviousDevices: customerData?.previousDevices?.length ?? 0,
        currentSubscriptions,
    };
}
